import { EditorCardProvider } from '@atlaskit/editor-card-provider';
import type { CardAppearance } from '@atlaskit/linking-common';

const isLoomUrl = (url: string) => {
	return url.match(
		// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
		/^https:\/\/(.*?\.)?(loom\..*?\/(share|embed))\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})/,
	);
};

export class InlineCommentEditorCardProvider extends EditorCardProvider {
	protected getHardCodedAppearance(url: string): CardAppearance | undefined {
		if (isLoomUrl(url)) {
			return 'embed';
		}
	}
}
